export const BR_LANGUAGE = 'language';
export const BR_WEB_URL = 'web_url';
export const BR_WEB_NAME = 'web_name';
export const BR_TIME = 'time';
export const BR_PAYSEND_ID = 'paysend-id';
export const BR_COUNTRY = 'country';
export const BR_DEFAULT_CURRENCY = 'default-currency';
export const BR_DEFAULT_COUNTRY = 'default-country';
export const BR_DEFAULT_AMOUNT = 'default-amount';
export const BR_CURRENCY = 'currency';
export const BR_SEND_CURRENCY = 'send-currency';
export const BR_CHOSEN_COUNTRY = 'chosen-country';
export const BR_AMOUNT = 'amount';
export const BR_AMOUNT_SEND_CURRENCY = 'amount-send-currency';
export const BR_WHAT_WAS_TYPED = 'what-was-typed';
export const BR_SENDING_COUNTRY_CODE = 'sending-country-code';
export const BR_RECEIVING_COUNTRY_CODE = 'receiving-country-code';
export const BR_REFERRAL_CODE = 'ref-code-name';
export const BR_REFERRAL_CODE_VALID = 'ref-code-valid';
export const BR_TRX_ID = 'trx-id';
export const BR_SOURCE_FUNDING = 'source-funding';
export const BR_SOURCE_FUNDING_ID = 'source-funding-id';
export const BR_DELIVERY_METHOD = 'delivery-method';
export const BR_DELIVERY_METHOD_ID = 'delivery-method-id';
export const BR_PROVIDER_ID = 'provider_id';
